export enum PredictionTypeEnum {
	Leaderboard = 1,
	Events = 2
}

